import { environment } from '../environment/environment';

const s3ToCDN = (url) => {
  const cdnDev = 'https://gqefcpylonobj.vcdn.cloud';
  if (!url) {
    return null;
  }

  if (url.includes(environment.CDN_GET_PRIVATE_RESOURCE)) {
    return url;
  }
  if (!url.includes('.amazonaws.com')) {
    return `${environment.CDN_GET_PRIVATE_RESOURCE}/${url}`;
  }
  const path = url.split('.amazonaws.com')[1];

  if (url.includes('-resource-dev')) {
    return `${cdnDev}${path}`;
  }
  return `${environment.CDN_GET_PRIVATE_RESOURCE}${path}`;
};

export const useS3Download = (resourcePath) => {
  const url = s3ToCDN(resourcePath);
  return {
    isSuccess: true,
    isLoading: false,
    data: {
      data: {
        downloadResourceUrl: url,
        path: resourcePath,
        resoureUrl: url,
      },
      downloadResourceUrl: url,
      path: resourcePath,
      resoureUrl: url,
    },
    downloadResourceUrl: url,
    path: resourcePath,
    resoureUrl: url,
  };
};
